import { Layout } from 'antd';
import styled from 'styled-components';
const { Sider } = Layout;

export const ContainerSider = styled(Sider)`
  will-change: width;
  transition: width 0.18s ease !important;
  background:
    radial-gradient(
      circle at top left,
      rgba(56, 189, 149, 0.2),
      transparent 22%
    ),
    radial-gradient(
      circle at bottom left,
      rgba(59, 130, 246, 0.14),
      transparent 28%
    ),
    linear-gradient(180deg, #0c1720 0%, #10212d 58%, #0d1824 100%);
  border-right: 1px solid rgba(148, 163, 184, 0.16);

  .ant-layout-sider-children {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    position: relative;
    contain: layout paint;
  }

  .ant-layout-sider-children::before {
    content: '';
    position: absolute;
    inset: 0;
    pointer-events: none;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.04) 0%,
      rgba(255, 255, 255, 0) 16%
    );
  }

  .ant-menu {
    background: transparent;
    border-inline-end: 0 !important;
    padding: 6px 10px 10px;
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: none;
    -ms-overflow-style: none;
    scrollbar-gutter: stable;
    contain: layout paint;
  }

  .ant-menu::-webkit-scrollbar {
    width: 0;
    height: 0;
    background: transparent;
  }

  .ant-menu-inline .ant-menu-item,
  .ant-menu-inline .ant-menu-submenu-title {
    border-radius: 14px;
    margin-inline: 0;
    width: 100%;
    margin-block: 4px;
    height: 44px;
    line-height: 44px;
    color: rgba(226, 232, 240, 0.88);
    transition:
      background-color 0.18s ease,
      color 0.18s ease,
      box-shadow 0.18s ease;
  }

  .ant-menu-inline .ant-menu-item:hover,
  .ant-menu-inline .ant-menu-submenu-title:hover {
    color: #f8fafc !important;
    background: rgba(148, 163, 184, 0.12) !important;
  }

  .ant-menu-item-selected {
    color: #f8fafc !important;
    background: linear-gradient(135deg, #166534 0%, #0f766e 100%) !important;
    box-shadow: 0 4px 10px rgba(15, 118, 110, 0.16);
  }

  .ant-menu-submenu-selected > .ant-menu-submenu-title,
  .ant-menu-submenu-open > .ant-menu-submenu-title {
    color: #f0fdf4 !important;
    background: rgba(20, 83, 45, 0.32) !important;
  }

  .ant-menu-sub {
    background: rgba(3, 10, 18, 0.2) !important;
    margin: 4px 0 10px;
    padding: 6px !important;
    border-radius: 16px;
    border: 1px solid rgba(148, 163, 184, 0.08);
  }

  .ant-menu-item-group-title {
    padding: 12px 10px 6px;
    color: #8fb0a4 !important;
    font-size: 11px;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    font-weight: 700;
  }

  .ant-menu-item-divider {
    margin: 12px 6px;
    background: rgba(148, 163, 184, 0.12) !important;
  }

  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
  -ms-overflow-style: none;
`;

export const ContainerLogo = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 14px;
  background: rgba(255, 255, 255, 0.94);
  margin: 12px 12px 10px;
  padding: 12px 14px;
  border-radius: 22px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  box-shadow: 0 8px 18px rgba(7, 16, 28, 0.12);
  overflow: hidden;
  transition:
    margin 0.18s ease,
    width 0.18s ease,
    height 0.18s ease,
    border-radius 0.18s ease,
    box-shadow 0.18s ease;

  .ant-layout-sider-collapsed & {
    place-items: center;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 60px;
    margin: 12px auto 10px;
    border-radius: 20px;
  }
`;

export const Logo = styled.img`
  width: 52px;
  height: 52px;
  flex: 0 0 auto;
  display: block;
  object-fit: contain;

  .ant-layout-sider-collapsed & {
    width: 40px;
    height: 40px;
  }
`;

export const ContainerHeaderTitle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  min-width: 0;
`;

export const HeaderEyebrow = styled.span`
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #5f7f73;
`;

export const TitleHeader = styled.div`
  font-size: 1.15rem;
  font-weight: 700;
  line-height: 1;
  color: #143d30;
`;

export const SidebarFooter = styled.div`
  padding: 10px 12px 14px;

  .ant-layout-sider-collapsed & {
    padding-inline: 8px;
  }
`;

export const SidebarUserCard = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(148, 163, 184, 0.12);
  color: #e2e8f0;

  .ant-layout-sider-collapsed & {
    justify-content: center;
    padding: 10px;
  }
`;

export const SidebarUserMeta = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;

  strong,
  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  strong {
    font-size: 0.92rem;
    color: #f8fafc;
  }

  span {
    font-size: 0.78rem;
    color: #94a3b8;
  }
`;

export const SidebarUserButton = styled.button`
  width: 100%;
  border: 0;
  padding: 0;
  background: transparent;
  text-align: left;
  cursor: pointer;
  border-radius: 18px;

  &:hover ${SidebarUserCard} {
    background: rgba(255, 255, 255, 0.12);
    border-color: rgba(148, 163, 184, 0.18);
  }
`;
